<kt-portlet>
  <kt-portlet-header
    [title]="'TABLE.AFFILIATION.RELATIONSHIP_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    class="card-head-lg"
  >
    <ng-container ktPortletTools>
      <div>
        <button
          *ngIf="!isViewMode"
          mat-raised-button
          color="primary"
          (click)="addAffiliationRelation($event)"
        >
          <span inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"></span>
          {{ 'TABLE.AFFILIATION.NEW_RELATIONSHIP' | translate }}
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table matSort class="mat-elevation-z8" [dataSource]="dataSource">
        <ng-container
          [matColumnDef]="
            entityType.localeCompare('AFFILIATION_GROUP') === 0
              ? 'contact_firstName'
              : 'affiliationGroup_name'
          "
        >
          <mat-header-cell mat-sort-header *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let relation">
            {{ getName(relation) }}
            <i *ngIf="relation.is_prime" class="flaticon2-correct icon-md text-success ml-2"></i>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="relationType_category_name">
          <mat-header-cell mat-sort-header *matHeaderCellDef>Category</mat-header-cell>
          <mat-cell *matCellDef="let relation">{{
            relation.relation_type?.category?.name
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="relationType_descriptionType">
          <mat-header-cell mat-sort-header *matHeaderCellDef>Description</mat-header-cell>
          <mat-cell *matCellDef="let relation">{{
            relation.relation_type?.description_type
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="classification">
          <mat-header-cell *matHeaderCellDef class="text-center">Classification</mat-header-cell>
          <mat-cell *matCellDef="let relation">
            <div class="d-flex svg-icon svg-icon-md">
              <div
                [matTooltip]="relation.financial_responsible ? 'Financial Responsible' : ''"
                [inlineSVG]="
                  relation.financial_responsible
                    ? './assets/media/svg/icons/General/dollar.svg'
                    : ''
                "
                style="height: 30px; width: 30px"
              ></div>
              <div
                [matTooltip]="relation.emergency_contact ? 'Emergency Contact' : ''"
                [inlineSVG]="
                  relation.emergency_contact ? './assets/media/svg/icons/General/siren.svg' : ''
                "
                style="height: 30px; width: 30px"
              ></div>
              <div
                [matTooltip]="relation.phi_authorized ? 'PHI Authorized' : ''"
                [inlineSVG]="
                  relation.phi_authorized ? './assets/media/svg/icons/General/hipaa_seal.svg' : ''
                "
                style="height: 30px; width: 30px"
              ></div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="text-center">{{
            'TABLE.ACTIONS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let relation">
            <button
              class="btn btn-icon btn-sm btn-light btn-hover-primary margin-2"
              matTooltip="{{ 'TABLE.UPDATE' | translate }} Affiliation Relation"
              (click)="updateAffiliationRelation($event, relation)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
            <button
              class="btn btn-icon btn-sm btn-light btn-hover-danger margin-2"
              matTooltip="{{ 'TABLE.DELETE' | translate }} Affiliation Relation"
              (click)="deleteAffiliationRelation($event, relation.id)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns"></mat-row>
      </mat-table>
      <div class="mat-table__message" *ngIf="!dataSource?.hasItems">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <div class="mat-table__message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLEASE_WAIT' | translate }}
      </div>
    </div>
    <div class="mat-table__bottom">
      <mat-spinner diameter="20" *ngIf="dataSource?.loading$ | async"></mat-spinner>
      <mat-paginator
        pageSize="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        showFirstLastButtons="true"
      ></mat-paginator>
    </div>
  </kt-portlet-body>
</kt-portlet>
